export function decimalToString(value, locale, fixed) {
    return value.toLocaleString(locale, {minimumFractionDigits:fixed, maximumFractionDigits:fixed});
}